import { Box } from '@mui/material';

import { DownloadModeloArquivoBtn } from 'components/buttons';
import { Block } from 'components/page';
import { SubTitle } from 'components/text';
import { DetalhamentoCreditosImportacaoUploadBtn } from 'pages/financeiro/detalhamento-creditos/importar/components';

export function DetalhamentoCreditosImportacaoItem() {
    return (
        <Block>
            <SubTitle label="Importar Arquivo - Detalhamento por Item" />

            <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <DownloadModeloArquivoBtn dsChave="URL_ARQUIVO_MODELO_DETALHAMENTO_CREDITO" />

                <DownloadModeloArquivoBtn text="Download do modelo do arquivo - Sell in" dsChave="URL_CONSULTA_DETALHAMENTO_CREDITO_DEBITO_SELLIN" />
            </Box>

            <DetalhamentoCreditosImportacaoUploadBtn url="/financeiro/detalhamentocreditodebitoimportacao/upload" />
        </Block>
    );
}
